<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ campaign.subject }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu v-if="this.$route.params.id"></submenu>

          <codemirror v-model="model.body" :options="editorOption"/>

          <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          <Btn v-on:click="$router.push({name: 'campaigns'})" label="Label_CancelButton" :withBorder="true" />
        </div>
      </div>
    </article>

  </article>
</template>

<script>
// require active-line.js
require('codemirror/addon/selection/active-line.js')
// styleSelectedText
require('codemirror/addon/selection/mark-selection.js')
require('codemirror/addon/search/searchcursor.js')
// highlightSelectionMatches
require('codemirror/addon/scroll/annotatescrollbar.js')
require('codemirror/addon/search/matchesonscrollbar.js')
require('codemirror/addon/search/searchcursor.js')
require('codemirror/addon/search/match-highlighter.js')
// keyMap
require('codemirror/mode/clike/clike.js')
require('codemirror/addon/edit/matchbrackets.js')
require('codemirror/addon/comment/comment.js')
require('codemirror/addon/dialog/dialog.js')
require('codemirror/addon/dialog/dialog.css')
require('codemirror/addon/search/searchcursor.js')
require('codemirror/addon/search/search.js')
require('codemirror/keymap/sublime.js')

import { TextBox, Btn } from 'components/layout/forms'
import Submenu from 'components/views/campaigns/Submenu'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'campaign-code',
  components: { Submenu, Validation, TextBox, Btn },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      L: L,
      model: {
        id: '',
        body: ''
      },
      editorOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/html',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { 'Ctrl': 'autocomplete' },
        hintOptions: {
          completeSingle: false
        }
      }
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getCampaign', this.$route.params.id).then(() => {
        this.mapFromState()
      })
    }
  },
  computed: {
    ...mapGetters({
      campaign: 'activeCampaign'
    })
  },
  validations: {
    model: {
      body: { required }
    }
  },
  methods: {
    mapFromState() {
      this.model.id = this.campaign.id
      if (!_.isEmpty(this.campaign.body)) {
        this.model.body = this.campaign.body
      }
    },
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      let campaign = this.model
      this.$store.dispatch('updateBody', campaign).then(
        // resolve
        () => {
          this.loading = false
          this.mapFromState()
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Label_Success')
          })
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// CampaignEditCode.vue?03d0badc